import React from 'react';

const SupplySourcesTab = ({ 
    supplySourceFiles, 
    setSupplySourceFiles,
    handleSupplyCheckboxChange, // Accept the prop with consistent naming
    selectedSupplySources,
    setHandleSendClickButton,
    handleSendClickButton,
    handleModalClose, // Receive the function to close the modal
    selectedDocuments, 
    inputText = '', // Provide a default value for inputText
    formHasValues,
}) => {
    console.log('supplySourceFiles:', supplySourceFiles);
    console.log("SupplySourcesTab formHasValues:", formHasValues); // Debug log
    console.log("SupplySourcesTab selectedSupplySources:", selectedSupplySources); // Debug log

    if (!supplySourceFiles) {
        console.error('supplySourceFiles is undefined');
        return <div>Error: No supply source files available.</div>;
    }

    const handleSubmit = async () => {
        // More detailed debug logs
        console.log("Submit triggered with details:", {
            selectedSupplySources: {
                length: selectedSupplySources.length,
                data: selectedSupplySources,
                isArray: Array.isArray(selectedSupplySources),
                type: typeof selectedSupplySources
            },
            formHasValues: {
                value: formHasValues,
                type: typeof formHasValues
            },
            selectedDocuments: {
                keys: Object.keys(selectedDocuments),
                data: selectedDocuments,
                type: typeof selectedDocuments
            }
        });

        // Check both conditions separately for better debugging
        if (!selectedSupplySources.length) {
            console.error("No supply sources selected");
            return;
        }

        if (!Object.keys(selectedDocuments).length && !formHasValues) {
            console.error("Neither documents nor form data available");
            return;
        }

        setHandleSendClickButton(true);
        handleModalClose();

        setTimeout(() => {
            setSupplySourceFiles(prevFiles => 
                prevFiles.map(file => ({ ...file, isChecked: false }))
            );
        }, 100);
    };

    const handleSelectAll = (e) => {
        const isChecked = e.target.checked;
        // Update the visual checkbox states
        setSupplySourceFiles(prevFiles => 
            prevFiles.map(file => ({ ...file, isChecked }))
        );
        // Update each file individually using the existing handler
        supplySourceFiles.forEach(file => {
            handleSupplyCheckboxChange(file.name, isChecked);
        });
    };

    const isSubmitDisabled = !selectedSupplySources.length || 
                            (!Object.keys(selectedDocuments).length && !formHasValues);

    console.log("Submit button disabled:", isSubmitDisabled); // Debug log

    return (
        <div>
            <h3>Supply Sources</h3>
            {supplySourceFiles.length ? (
                <>
                    <div style={{ marginBottom: '10px', marginLeft: '5px' }}>
                        <input 
                            type="checkbox"
                            checked={supplySourceFiles.every(file => file.isChecked)}
                            onChange={handleSelectAll}
                            id="selectAll"
                        />
                        <label htmlFor="selectAll" style={{ marginLeft: '5px', fontWeight: 'bold' }}>Select All</label>
                    </div>
                    <ul>
                        {supplySourceFiles.map((file, index) => (
                            <li key={file.id || index}>
                                <input 
                                    type="checkbox"
                                    checked={file.isChecked || false}
                                    onChange={(e) => handleSupplyCheckboxChange(file.name, e.target.checked)}
                                /> {file.name}
                            </li>
                        ))}
                    </ul>
                </>
            ) : (
                <p>No supply sources available.</p>
            )}
            <button
                onClick={handleSubmit}
                disabled={isSubmitDisabled}
                style={{ marginTop: '20px' }}>
                Submit
            </button>
        </div>
    );
};

export default SupplySourcesTab;